var moduleMap = {
	"./UnityDashboard": () => {
		return Promise.all(/* __federation_expose_UnityDashboard */[__webpack_require__.e(4786), __webpack_require__.e(8853), __webpack_require__.e(1454), __webpack_require__.e(9119), __webpack_require__.e(5921), __webpack_require__.e(3081), __webpack_require__.e(6426), __webpack_require__.e(8491), __webpack_require__.e(5350), __webpack_require__.e(6445), __webpack_require__.e(5281), __webpack_require__.e(7757), __webpack_require__.e(1611), __webpack_require__.e(1902), __webpack_require__.e(5029), __webpack_require__.e(5059), __webpack_require__.e(5302), __webpack_require__.e(4482), __webpack_require__.e(7732), __webpack_require__.e(3760), __webpack_require__.e(2019), __webpack_require__.e(5132), __webpack_require__.e(299), __webpack_require__.e(6553), __webpack_require__.e(1860), __webpack_require__.e(2717), __webpack_require__.e(2008), __webpack_require__.e(6275), __webpack_require__.e(807), __webpack_require__.e(3110), __webpack_require__.e(7460), __webpack_require__.e(8099), __webpack_require__.e(8062), __webpack_require__.e(8551), __webpack_require__.e(3362), __webpack_require__.e(546), __webpack_require__.e(2272), __webpack_require__.e(3629), __webpack_require__.e(9723), __webpack_require__.e(9764), __webpack_require__.e(9405), __webpack_require__.e(5022), __webpack_require__.e(1770), __webpack_require__.e(2328), __webpack_require__.e(2256), __webpack_require__.e(8076), __webpack_require__.e(8217), __webpack_require__.e(3156), __webpack_require__.e(1537), __webpack_require__.e(5219), __webpack_require__.e(1016)]).then(() => (() => ((__webpack_require__(56857)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});